import i18n from "../i18n";
import ValidationResult from "../interfaces/api/validation-result";

export const validateName = (name: string | null, takenNames: string[] | null = null): ValidationResult[] => {
  const errors: ValidationResult[] = [];
  if (name == null || name.length === 0) {
    errors.push({ isValid: false, error: i18n.t("validation-error-name-empty") });
  }
  if (name !== null && name.length > 80) {
    errors.push({ isValid: false, error: i18n.t("validation-error-name-too-long") });
  }

  const specialChars = /[`!@#$%^&*()+=[\]{};':"\\|,.<>/?~]/;
  if (name !== null && specialChars.test(name)) {
    errors.push({ isValid: false, error: i18n.t("validation-error-name-includes-special-chars") });
  }

  if (takenNames != null && takenNames.some((n) => n === name)) {
    errors.push({ isValid: false, error: i18n.t("validation-error-name-duplicate") });
  }

  return errors;
};